import React, { useRef } from "react";
import { projectsAPI } from "../../api/client";

function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * "Project Documents" upload section shared by the add and edit project modals.
 * - existing: documents already saved on the project ({ name, path, size })
 * - files: newly picked File objects, not yet uploaded
 */
export default function ProjectDocumentsField({
  existing = [],
  files = [],
  onExistingChange,
  onFilesChange,
  disabled = false,
  required = false,
}) {
  const inputRef = useRef(null);

  const addFiles = (fileList) => {
    const picked = Array.from(fileList || []);
    if (picked.length) onFilesChange([...files, ...picked]);
    // Reset so picking the same file again still fires onChange
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="form-section">
      <div className="form-group">
        <label htmlFor="project-documents-input">
          Project Documents
          {required && <span style={{ color: "#ef4444" }}> *</span>}
        </label>
        <input
          id="project-documents-input"
          ref={inputRef}
          type="file"
          multiple
          disabled={disabled}
          onChange={(e) => addFiles(e.target.files)}
        />
        <small className="small-muted">
          Any file type, up to 25 MB each.
        </small>
      </div>

      {(existing.length > 0 || files.length > 0) && (
        <div className="project-documents-list">
          {existing.map((doc) => (
            <div key={doc.path} className="project-document-row">
              <span className="project-document-name" title={doc.name}>
                {doc.name}
                {doc.size ? (
                  <span className="small-muted"> · {formatSize(doc.size)}</span>
                ) : null}
              </span>
              <span className="project-document-actions">
                <a
                  href={projectsAPI.projectFileUrl(doc.path)}
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
                {!disabled && onExistingChange && (
                  <button
                    type="button"
                    className="btn-danger btn-sm"
                    onClick={() =>
                      onExistingChange(existing.filter((d) => d.path !== doc.path))
                    }
                  >
                    Remove
                  </button>
                )}
              </span>
            </div>
          ))}
          {files.map((file, index) => (
            <div key={`${file.name}-${index}`} className="project-document-row">
              <span className="project-document-name" title={file.name}>
                {file.name}
                <span className="small-muted">
                  {" "}
                  · {formatSize(file.size)} · new
                </span>
              </span>
              {!disabled && (
                <span className="project-document-actions">
                  <button
                    type="button"
                    className="btn-danger btn-sm"
                    onClick={() =>
                      onFilesChange(files.filter((_, i) => i !== index))
                    }
                  >
                    Remove
                  </button>
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
